import fuse from '../../../_libs/redux-fusion';
import {ReduxListStreamedContainer} from '../../../core-utilities/redux/ReduxListContainer';
import {pauseTimer, startTimer, stopTimer} from '../../actions';
import {componentOptions, reduxList} from '../../redux/activeTimers';
import {ActiveTimerListComponent} from './ActiveTimerListComponent';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const onStartTimer = model => dispatch(startTimer({
    startedAt: new Date().getTime(),
    id: model.id,
    requestId: model.requestId,
  }));
  const onPauseTimer = model => dispatch(pauseTimer({
    id: model.id,
    requestId: model.requestId,
    endedAt: new Date().getTime(),
  }));
  const onStopTimer = model => dispatch(stopTimer({
    id: model.id,
    requestId: model.requestId,
    endedAt: new Date().getTime(),
  }));

  return props$
    .map(props => ({
      ...props,
      onStartTimer,
      onPauseTimer,
      onStopTimer,
    }));
};

const ListComponent = ReduxListStreamedContainer(ActiveTimerListComponent, reduxList, componentOptions);
export const ActiveTimerListContainer = fuse(StreamedComponent)(ListComponent);



// WEBPACK FOOTER //
// ./src/js/timers/components/ActiveTimerList/ActiveTimerListContainer.js